import React, { useEffect } from "react";
import useSound from "use-sound";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  bounce_right_to_left_variants_delay,
  bounce_right_to_left_variants_without_children
} from "shared/components/animations";
import scoredImg from "assets/images/sbs/tot-new/Scored.png";
import skippedImg from "assets/images/sbs/tot-new/skipped.png";

const GuessingAfterAction = ({ scorerData, emptyTotMessage }) => {
  const [buzzer_sound] = useSound(scorerData.audio_effect);

  useEffect(() => {
    buzzer_sound();
    setTimeout(() => {
      emptyTotMessage();
    }, 1500);
  }, [buzzer_sound]);

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="tot-skipped-wrapper"
    >
      {scorerData.message === "Skipped" ? (
        <motion.img
          variants={bounce_right_to_left_variants_without_children}
          alt=""
          src={skippedImg}
        />
      ) : (
        <motion.img
          variants={bounce_right_to_left_variants_without_children}
          alt=""
          src={scoredImg}
        />
      )}
      <span>by</span>
      <motion.div
        variants={bounce_right_to_left_variants_delay}
        className="tot-guesser-img-div"
      >
        <img alt="" className="guesser-img" src={scorerData.profile_image} />
      </motion.div>
      <span>{scorerData.display_name}</span>
    </motion.div>
  );
};

export default GuessingAfterAction;
